<p>inactivity-timer works!</p>
